export const SET_OPENED_TAB = 'SET_OPENED_TAB';
export const IS_SHOW_ADD_TEAM = 'IS_SHOW_ADD_TEAM';

export const GET_TEAMS_LIST_REQUEST = 'GET_TEAMS_LIST_REQUEST';
export const GET_TEAMS_LIST_SUCCESS = 'GET_TEAMS_LIST_SUCCESS';

export const DELETE_TEAM_SUCCESS = 'DELETE_TEAM_SUCCESS';
export const DELETE_TEAM_REQUEST = 'DELETE_TEAM_REQUEST';
export const DELETE_TEAM_FAILURE = 'DELETE_TEAM_FAILURE';

export const EDIT_TEAM_REQUEST = 'EDIT_TEAM_REQUEST';
export const EDIT_TEAM_FAILURE = 'EDIT_TEAM_FAILURE';
export const EDIT_TEAM_SUCCESS = 'EDIT_TEAM_SUCCESS';

export const GENERATE_INVITE_LINK_TEAM_REQUEST = 'GENERATE_INVITE_LINK_TEAM_REQUEST';
export const GENERATE_INVITE_LINK_TEAM_SUCCESS = 'GENERATE_INVITE_LINK_TEAM_SUCCESS';
export const GENERATE_INVITE_LINK_TEAM_FAILURE = 'GENERATE_INVITE_LINK_TEAM_FAILURE';

export const ADD_USERS_TEAM_REQUEST = 'ADD_USERS_TEAM_REQUEST';
export const ADD_USERS_TEAM_SUCCESS = 'ADD_USERS_TEAM_SUCCESS';
export const ADD_USERS_TEAM_FAILURE = 'ADD_USERS_TEAM_FAILURE';

export const ADD_USERS_IN_TEAMS_BY_INVITATION_REQUEST = 'ADD_USERS_IN_TEAMS_BY_INVITATION_REQUEST'
export const ADD_USERS_IN_TEAMS_BY_INVITATION_SUCCESS = 'ADD_USERS_IN_TEAMS_BY_INVITATION_SUCCESS'
export const ADD_USERS_IN_TEAMS_BY_INVITATION_FAILURE = 'ADD_USERS_IN_TEAMS_BY_INVITATION_FAILURE'

export const REMOVE_TEAM_AGENT_REQUEST = 'REMOVE_TEAM_AGENT_REQUEST';
export const REMOVE_TEAM_AGENT_SUCCESS = 'REMOVE_TEAM_AGENT_SUCCESS';
export const REMOVE_TEAM_AGENT_FAILURE = 'REMOVE_TEAM_AGENT_FAILURE';


export const GET_TEAM_USERS_LIST_REQUEST = 'GET_TEAM_USERS_LIST_REQUEST';
export const GET_TEAM_USERS_LIST_SUCCESS = 'GET_TEAM_USERS_LIST_SUCCESS';
export const GET_TEAM_USERS_LIST_FAILURE = 'GET_TEAM_USERS_LIST_FAILURE';


export const CREATE_NEW_TEAM_REQUEST = 'CREATE_NEW_TEAM_REQUEST';
export const CREATE_NEW_TEAM_SUCCESS = 'CREATE_NEW_TEAM_SUCCESS';
export const CREATE_NEW_TEAM_FAILURE = 'CREATE_NEW_TEAM_FAILURE';



export const LINK_PROJECT_REQUEST = 'LINK_PROJECT_REQUEST';
export const LINK_PROJECT_SUCCESS = 'LINK_PROJECT_SUCCESS';
export const LINK_PROJECT_FAILURE = 'LINK_PROJECT_FAILURE';



export const UNLINK_PROJECT_REQUEST = 'UNLINK_PROJECT_REQUEST';
export const UNLINK_PROJECT_SUCCESS = 'UNLINK_PROJECT_SUCCESS';
export const UNLINK_PROJECT_FAILURE = 'UNLINK_PROJECT_FAILURE';


export const GET_LINKED_PROJECTS_REQUEST = 'GET_LINKED_PROJECTS_REQUEST';
export const GET_LINKED_PROJECTS_SUCCESS = 'GET_LINKED_PROJECTS_SUCCESS';
export const GET_LINKED_PROJECTS_FAILURE = 'GET_LINKED_PROJECTS_FAILURE';


export const GET_TEAMS_DROPDOWN_LIST_REQUEST = 'GET_TEAMS_DROPDOWN_LIST_REQUEST';
export const GET_TEAMS_DROPDOWN_LIST_SUCCESS = 'GET_TEAMS_DROPDOWN_LIST_SUCCESS';
export const GET_TEAMS_DROPDOWN_LIST_FAILURE = 'GET_TEAMS_DROPDOWN_LIST_FAILURE';






export const CLEAR_TEAM_USERS_DROPDOWN_LIST_DATA = 'CLEAR_TEAM_USERS_DROPDOWN_LIST_DATA'
export const CLEAR_TEAMS_DROPDOWN_LIST_DATA = 'CLEAR_TEAMS_DROPDOWN_LIST_DATA'


export const GET_TEAMS_USERS_LIST_REQUEST = 'GET_TEAMS_USERS_LIST_REQUEST'
export const GET_TEAMS_USERS_LIST_SUCCESS = 'GET_TEAMS_USERS_LIST_SUCCESS'
